import { render } from "./LayoutGuest.vue?vue&type=template&id=2a916c6b"
import script from "./LayoutGuest.vue?vue&type=script&lang=js"
export * from "./LayoutGuest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__